import { useRef, useState } from "react";
import { Sheet, Button } from "./ui";
import { Icon } from "./icons";

/** Touch-and-hold (or right-click) opens the message options. */
export function useLongPress(onLong, ms = 500) {
  const t = useRef(null);
  const clear = () => clearTimeout(t.current);
  return (m) => ({
    onTouchStart: () => { clear(); t.current = setTimeout(() => onLong(m), ms); },
    onTouchEnd: clear,
    onTouchMove: clear,
    onTouchCancel: clear,
    onContextMenu: (e) => { e.preventDefault(); onLong(m); },
  });
}

export function MessageMenu({ message, mine, canEdit, canDelete, onClose, onEdit, onDelete }) {
  const [confirm, setConfirm] = useState(false);
  const preview = message.type && message.type !== "text" ? message.filename || "Anexo" : message.text;
  return (
    <Sheet title={confirm ? "Eliminar mensagem?" : "Mensagem"} onClose={onClose} testid="chat-message-sheet">
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div className="card" style={{ padding: 12 }}>
          <div className="t-hint">{mine ? "A sua mensagem" : message.user_name}</div>
          <div style={{ fontSize: 14, whiteSpace: "pre-wrap", maxHeight: 120, overflow: "hidden" }}>{preview}</div>
        </div>
        {confirm ? (
          <>
            <div className="t-hint">Só esta mensagem{message.type && message.type !== "text" ? " e o respetivo anexo deixam" : " deixa"} de estar visível para todos os participantes. A conversa mantém-se.</div>
            <div style={{ display: "flex", gap: 8 }}>
              <Button className="ghost" onClick={() => setConfirm(false)} data-testid="chat-delete-cancel">CANCELAR</Button>
              <Button onClick={onDelete} data-testid="chat-delete-confirm" style={{ background: "var(--error)" }}>ELIMINAR</Button>
            </div>
          </>
        ) : (
          <>
          {canEdit ? (
            <button className="card" onClick={onEdit} data-testid="chat-action-edit" style={{ display: "flex", alignItems: "center", gap: 10, padding: 14, cursor: "pointer", color: "inherit", textAlign: "left" }}>
              <Icon name="pencil" size={18} /> Editar mensagem
            </button>
          ) : null}
          {canDelete ? <button className="card" onClick={() => setConfirm(true)} data-testid="chat-delete-message" style={{ display: "flex", alignItems: "center", gap: 10, padding: 14, cursor: "pointer", color: "var(--on-error)", textAlign: "left" }}>
            <Icon name="trash" size={18} /> {mine ? "Eliminar a minha mensagem" : "Eliminar mensagem (moderação)"}
          </button> : null}
          </>
        )}
      </div>
    </Sheet>
  );
}
